import React, { useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import httpService from "../../services/httpService";

BlogSec1.propTypes = {};

function BlogSec1(props) {
  const { data,
    topNewsData,
    ILRData,
    countriesData,
    familyClassData,
    UKWorkData,
    UKStudyData,
    UKVisitData,
    UKSettlingData,
    latestNews,
    UKCommunityData,
    loadLatestNews,
    loader,
  } = props;
  const [searchword, setSearchword] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [searchActivated, setSearchActivated] = useState(false);

  const searchNews = async (e) => {
    e.preventDefault();
    try {
      const res = await httpService.get(`news/search?title=${searchword.trim()}&tags=${searchword.trim()}&match=all`);

      setSearchResults(res.data.data.news);
      setSearchActivated(true);
    } catch (error) { }
  };

  const renderPost = (idx) => <div key={idx.id} className="widget-blog-1" style={{
    display: "flex",
    alignItems: "center",
    gap: "16px",
    marginBottom: "20px",
    backgroundColor: "#fff",
    // borderRadius: "8px",
    padding: "10px",
  }}>
    <img src={idx.bannerImage} alt="image" className="img-blog" style={{
      width: "200px",          // fixed width
      height: "150px",         // fixed height (square)
      objectFit: "cover",    // keeps full image clear, not cropped
      backgroundColor: "#f8f8f8",
      borderRadius: "8px",
      flexShrink: 0,           // prevents image from shrinking
    }}
    />
    <div className="content" style={{
      flex: 1,                // text takes remaining space
    }}>
      <span className="sub-title">{formatSlug(idx.category)}</span>
      <h4 className="main-title" style={{ margin: "8px 0" }}>
        <Link to={`/news/${idx.slug}`}>{idx.title}</Link>
      </h4>
      <p className="main-title">{idx.abstract}</p>
      {/* <div className="widget-button-underline" style={{ marginTop: "8px" }}>
                        <Link to={`/news/${idx.slug}`}>Read More</Link>
                      </div> */}
    </div>
  </div>


  function formatSlug(slug) {
    return slug
      .split("-")
      .map(word =>
        word.toUpperCase() === "UK"
          ? "UK"
          : word.charAt(0).toUpperCase() + word.slice(1)
      )
      .join(" ");
  };

  return (
    <section>
      <div className="tf-container">

        <br />

        {/* search here */}
        <form
          role="search"
          className="widget-block-search-2"
        >
          <div className="widget-block-search-2-wrap">
            <input
              type="search"
              className="widget-block-search-2-input "
              placeholder="Search"
              required="true"
              onChange={(e) => { setSearchword(e.target.value); setSearchActivated(false); }}
            />
            <button onClick={(e) => searchNews(e)} className="widget-block-search-2-button">
              <span className="icon-search1"></span>
            </button>
          </div>
        </form>

        {/* search results*/}
        {searchActivated && searchword.length !== 0 ? (
          <div className="blog wrap-blog stc">
            <div className="list-blog listBlog-wrap">
              <h5 className="main-heading">
                Search results for `<i>{searchword}</i>`
              </h5>
              <br />
              {searchResults.map((idx) => (
                renderPost(idx)
              ))}

              {searchResults.length === 0 && <i>
                There are no results for {searchword}
              </i>}
            </div>
          </div>
        ) : (
          <>

            {/* others */}

            <h3 className="main-heading">
              Latest
            </h3>
            <br />
            {loadLatestNews ? (
              <div className="loader">
                <div className="spinner"></div>
              </div>
            ) : (
              <div className="group-col-3">
                {latestNews.slice(0, 3).map((idx) => (
                  <div key={idx.id} className="widget-blog-1 style-1 cl3 stc">
                    <div className="img-blog">
                      <img src={idx.bannerImage} alt="image" style={{
                        width: "100%",
                        height: "250px",
                        objectFit: "cover",
                        backgroundColor: "#f8f8f8", // optional, fills space behind image
                        borderRadius: "1px" // optional
                      }} />
                    </div>
                    <div className="content">
                      <span className="sub-title">{formatSlug(idx.category)}</span>
                      <h3 className="main-title"><Link to={`/news/${idx.slug}`}>{idx.title}</Link></h3>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {loadLatestNews === false && <div className="widget-button-underline">
              <Link to="/news/category/latest">Read More Latest News</Link>
            </div>}

            {/* Indefinite Leave to Remain (ILR) */}
            <div className="blog wrap-blog stc">
              <div className="list-blog listBlog-wrap">
                <h5 className="main-heading">
                  Indefinite Leave to Remain (ILR)
                </h5>
                <br />
                {loader ? (
                  <div className="loader">
                    <div className="spinner"></div>
                  </div>
                ) : (<>{ILRData.slice(0, 5).map((idx) => (
                  renderPost(idx)
                ))}</>)}

                {loader === false ? <> {ILRData.length > 0 ? (<div className="widget-button-underline">
                  <Link to="/news/category/indefinite-leave-to-remain-ilr">Read More News on ILR</Link>
                </div>) : (<i>
                  There are no news on ILR
                </i>)}</> : null}
              </div>
            </div>

            {/* Countries Immigration */}
            <div className="blog wrap-blog stc">
              <div className="list-blog listBlog-wrap">
                <h5 className="main-heading">
                  Countries Immigration
                </h5>
                <br />
                {loader ? (
                  <div className="loader">
                    <div className="spinner"></div>
                  </div>
                ) : (<>{countriesData.slice(0, 5).map((idx) => (
                  renderPost(idx)
                ))}</>)}

                {loader === false ? <>{countriesData.length > 0 ? (<div className="widget-button-underline">
                  <Link to="/news/category/countries-immigration">Read More News on Countries Immigration</Link>
                </div>) : (<i>
                  There are no news on Countries Immigration
                </i>)}</> : null}
              </div>
            </div>

            {/* Family Immigration */}
            <div className="blog wrap-blog stc">
              <div className="list-blog listBlog-wrap">
                <h5 className="main-heading">
                  Family Sponsorship
                </h5>
                <br />
                {loader ? (
                  <div className="loader">
                    <div className="spinner"></div>
                  </div>
                ) : (<>{familyClassData.slice(0, 5).map((idx) => (
                  renderPost(idx)
                ))}</>)}

                {loader === false ? <>{familyClassData.length > 0 ? (<div className="widget-button-underline">
                  <Link to="/news/category/family-sponsorship">Read More News on Family Sponsorship</Link>
                </div>) : (<i>
                  There are no news on Family Sponsorship
                </i>)}</> : null}
              </div>
            </div>


            {/*   Working in UK */}
            <div className="blog wrap-blog stc">
              <div className="list-blog listBlog-wrap">
                <h5 className="main-heading">
                  Working in UK
                </h5>
                <br />
                {loader ? (
                  <div className="loader">
                    <div className="spinner"></div>
                  </div>
                ) : (<>{UKWorkData.slice(0, 5).map((idx) => (
                  renderPost(idx)
                ))}</>)}

                {loader === false ? <>{UKWorkData.length > 0 ? (<div className="widget-button-underline">
                  <Link to="/news/category/work">Read More News on Working in UK</Link>
                </div>) : (<i>
                  There are no news on Working in UK
                </i>)}</> : null}
              </div>
            </div>

            {/*   Studying in UK */}
            <div className="blog wrap-blog stc">
              <div className="list-blog listBlog-wrap">
                <h5 className="main-heading">
                  Studying in UK
                </h5>
                <br />
                {loader ? (
                  <div className="loader">
                    <div className="spinner"></div>
                  </div>
                ) : (<>{UKStudyData.slice(0, 5).map((idx) => (
                  renderPost(idx)
                ))}</>)}

                {loader === false ? <>{UKStudyData.length > 0 ? (<div className="widget-button-underline">
                  <Link to="/news/category/study">Read More News on Studying in UK</Link>
                </div>) : (<i>
                  There are no news on Studying in UK
                </i>)}</> : null}
              </div>
            </div>

            {/*    Visiting the UK */}
            <div className="blog wrap-blog stc">
              <div className="list-blog listBlog-wrap">
                <h5 className="main-heading">
                  Visiting the UK
                </h5>
                <br />
                {loader ? (
                  <div className="loader">
                    <div className="spinner"></div>
                  </div>
                ) : (<>{UKVisitData.slice(0, 5).map((idx) => (
                  renderPost(idx)
                ))}</>)}

                {loader === false ? <>{UKVisitData.length > 0 ? (<div className="widget-button-underline">
                  <Link to="/news/category/visit">Read More News on Visiting the UK</Link>
                </div>) : (<i>
                  There are no news on Visiting the UK
                </i>)}</> : null}
              </div>
            </div>


            {/*     Settling in UK */}
            <div className="blog wrap-blog stc">
              <div className="list-blog listBlog-wrap">
                <h5 className="main-heading">
                  Settling in UK
                </h5>
                <br />
                {loader ? (
                  <div className="loader">
                    <div className="spinner"></div>
                  </div>
                ) : (<>{UKSettlingData.slice(0, 5).map((idx) => (
                  renderPost(idx)
                ))}</>)}

                {loader === false ? <>{UKSettlingData.length > 0 ? (<div className="widget-button-underline">
                  <Link to="/news/category/settling-in-the-uk">Read More News on Settling in UK</Link>
                </div>) : (<i>
                  There are no news on Settling in UK
                </i>)}</> : null}
              </div>
            </div>

            {/*     Settling in UK */}
            <div className="blog wrap-blog stc">
              <div className="list-blog listBlog-wrap">
                <h5 className="main-heading">
                  Community
                </h5>
                <br />
                {loader ? (
                  <div className="loader">
                    <div className="spinner"></div>
                  </div>
                ) : (<>{UKCommunityData.slice(0, 5).map((idx) => (
                  renderPost(idx)
                ))}</>)}

                {loader === false ? <>{UKCommunityData.length > 0 ? (<div className="widget-button-underline">
                  <Link to="/news/category/community">Read More News on Community</Link>
                </div>) : (<i>
                  There are no news on Community
                </i>)}</> : null}
              </div>
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default BlogSec1;
